// Angular
import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
 } from '@angular/core';

@Component({
  selector: 'app-bulkcancelpopover',
  templateUrl: './bulkcancelpopover.component.html',
  styleUrls: ['./bulkcancelpopover.component.scss']
})
export class BulkcancelpopoverComponent implements OnInit{

  @Input() title: string;
  @Input() eligibleBookingIds: string[];
  @Input() nonEligibleBookingIds: string[];
  @Input() cancelPopupConfig: any;
  @Output() closeBookingDetailsCallback = new EventEmitter();
  @Output() dismissCallback = new EventEmitter();
  @Output() approveCallback = new EventEmitter();

  isYesClicked = false;
  reasonText: string;
  isSubmitReasonClicked = false;
  selectedBookingsText: string;
  nonEligibleBookingText: string;
  maxLimit = 100;


  ngOnInit(): void {
    if (this.eligibleBookingIds.length) {
      const bookings = this.eligibleBookingIds.join(",   ");
      this.selectedBookingsText = `Are you sure you want to cancel bookings ${bookings} ?`;

    }
    if (this.nonEligibleBookingIds.length) {
      this.nonEligibleBookingText = this.nonEligibleBookingIds.join(",   ") + " can not be cancelled since cutoff time is already passed.";
    }
  }

  handleCloseBookingDetails() {
    if (this.closeBookingDetailsCallback) {
      this.closeBookingDetailsCallback.emit();
    }
  }

  onYesClick() {
    this.isYesClicked = true;
  }

  cancelCallback() {
    this.dismissCallback.emit();
  }

  submitReasonAndCancel() {
    this.isSubmitReasonClicked = true;
    if (this.cancelPopupConfig.config.visibility.visible && this.cancelPopupConfig.config.mandatory) {
      if (this.reasonText && this.reasonText.length <= this.maxLimit) {
        this.approveCallback.emit(this.reasonText);
      }
    } else {
      if (this.reasonText) {
        if (this.reasonText.length <= this.maxLimit) {
          this.approveCallback.emit(this.reasonText);
        }
      } else {
        this.approveCallback.emit("");
      }
    }
  }

}
